import { useTheme } from "@emotion/react"
import {
  Box,
  Card,
  CardActionArea,
  CardHeader,
  CardMedia,
  Chip,
} from "@mui/material"
import React from "react"
import { deepmerge } from "@mui/utils"

export const ImageCard = ({
  title,
  subheader,
  image,
  onClick = () => {},
  avatar,
  fallbackImage = null,
  fallbackImageIcon = null,
  tag,
  sx,
  ...props
}) => {
  const theme = useTheme()
  const { chip, chipContainer, root } =
    //@ts-ignore
    theme.components[`ImageCard`]?.styleOverrides || {}
  const hasImage = image || fallbackImage

  return (
    <Card
      //@ts-ignore
      variant="image"
      className={!hasImage ? "no-image" : ""}
      {...props}
      sx={deepmerge(root, sx)}
    >
      <CardActionArea onClick={onClick}>
        <Box sx={chipContainer}>
          {typeof tag === "string" ? (
            <Chip label={tag} size="small" sx={chip} />
          ) : (
            tag
          )}
        </Box>
        {hasImage || !fallbackImageIcon ? (
          <CardMedia component="img" image={image || fallbackImage} />
        ) : (
          fallbackImageIcon
        )}
        <CardHeader title={title} subheader={subheader} avatar={avatar} />
      </CardActionArea>
    </Card>
  )
}
